import { tns } from 'tiny-slider/src/tiny-slider';

(function () {

  if (!document.body.classList.contains('home')) return this;

  const home_slider = tns({
    autoplay: true,
    autoplayButtonOutput: false,
    container: '.interview-slider__container',
    items: 1,
    mode: 'carousel',
    slideBy: 'page',
    navPosition: "bottom",
    controlsText: ["<span>前へ</span>", "<span>次へ</span>"],
    animateDelay: 6000,
    speed: 1000,
  });

  console.log(home_slider);

})();
